<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <h2>
          <v-icon class="mr-2">
            mdi-scale
          </v-icon>
          売上品目単位
        </h2>
        <v-spacer class="mt-2" />
      </v-col>
    </v-row>

    <!-- ボタン -->
    <v-row>
      <v-col cols="12" class="text-right">
        <v-btn
          color="primary"
          @click="addButtonClickEvent"
        >
          単位の追加&nbsp;<v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <!-- /ボタン -->

    <v-row>
      <v-col>
        <custom-pagination
          :page-number="page"
          :per-page="perPage"
          :pagination="pagination"
          :total-visible="totalVisible"
          @pageChanged="changePage"
          @perPageChanged="changePerPage"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-card flat class="rounded-card">
          <v-data-table
            :headers="tableHeaders"
            :items="salesItemUnits"
            :items-per-page="-1"
            hide-default-footer
            dense
            disable-sort
            disable-pagination
          >
            <template v-slot:[`item.created_at`]="{ item }">
              {{ item.created_at | unix_datetime_format }}
            </template>
            <template v-slot:[`item.updated_at`]="{ item }">
              {{ item.updated_at | unix_datetime_format }}
            </template>
            <template v-slot:[`item.editable`]="{ item }">
              <v-btn
                :icon="$vuetify.breakpoint.mdAndUp"
                :text="$vuetify.breakpoint.smAndDown"
                :color="`info ${$vuetify.breakpoint.mdAndUp ? 'darken-2': null}`"
                @click="editButtonClickEvent(item)"
              >
                <v-icon v-if="$vuetify.breakpoint.mdAndUp">
                  mdi-note-edit
                </v-icon>
                <span v-else>編集</span>
              </v-btn>

              <v-btn
                v-if="item.can_remove"
                :icon="$vuetify.breakpoint.mdAndUp"
                :text="$vuetify.breakpoint.smAndDown"
                :color="`error ${$vuetify.breakpoint.mdAndUp ? 'darken-2': null}`"
                @click="deleteButtonClickEvent(item)"
              >
                <v-icon v-if="$vuetify.breakpoint.mdAndUp">
                  mdi-trash-can-outline
                </v-icon>
                <span v-else>削除</span>
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <!-- ページャ -->
    <v-row>
      <v-col>
        <custom-pagination
          :page-number="page"
          :per-page="perPage"
          :pagination="pagination"
          :total-visible="totalVisible"
          @pageChanged="changePage"
          @perPageChanged="changePerPage"
        />
      </v-col>
    </v-row>
    <!-- /ページャ -->

    <!-- /ダイアログ -->
    <itemUnit-regist-dialog
      :enable-dialog="enableItemUnitDialog"
      :target-id="targetId"
      @closeEvent="closeItemUnitDialog"
      @registerEvent="itemUnitCallback"
    />
    <!-- ダイアログ -->

    <confirm ref="confirm" />
  </v-container>
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex'
import Confirm from '../../../../components/Confirm'
import ItemUnitRegistDialog from './dialogs/ItemUnitRegistDialog'
import DownloadMixin from '../../../../mixins/download-mixin'
import CustomPagination from "@/driver/components/_CustomPagination.vue";

export default {
  name: 'SalesItemUnitIndex',
  components: { CustomPagination, Confirm, ItemUnitRegistDialog },
  mixins: [
    DownloadMixin,
  ],
  data() {
    return {
      page: 1,
      perPage: 50,
      totalVisible: 5,
      withDeleted: false,
      targetId: null,
      enableItemUnitDialog: false,
      tableHeaders: [
        { text: 'コード', value: 'code' },
        { text: '単位名', value: 'name' },
        { text: '並び順', value: 'sort_priority', align: 'end' },
        { text: 'データ作成日時', value: 'created_at' },
        { text: 'データ更新日時', value: 'updated_at' },
        { text: '編集・削除', value: 'editable', align: 'end' },
      ],
      salesItemUnits: [],
    }
  },
  computed: {
    ...mapState('DriverMasterSalesItemUnit', {
      pagination: 'pagination',
      searchCondition: 'condition',
    }),
    ...mapGetters('DriverMasterSalesItemUnit', [
      'hasResult'
    ]),
  },
  watch: {},
  created() {
    if (this.$route.params.resetCondition) {
      this.resetState()
    }
    if (this.$route.params.resetPagination) {
      this.resetPagination()
    }
    this.page = this.pagination.current_page
    this.perPage = this.searchCondition.limit

    this.searchItemUnit()

  },
  methods: {
    /** api取得 */
    ...mapActions('DriverMasterSalesItemUnit', {
      fetchSalesItemUnits: 'index',
      deleteItemUnit: 'destroy',
      resetState: 'resetState',
      resetPagination: 'resetPagination',
    }),
    // /** 取扱品目 api取得*/
    // ...mapActions('DriverMasterSearchItem', {
    //   fetchItems: 'index',
    // }),
    /**
     * 追加ボタン クリックイベント
     */
    addButtonClickEvent () {
      this.targetId = null
      this.enableItemUnitDialog = true
    },

    /**
     * 編集ボタン クリックイベント
     * @param item { Object }
     */
    editButtonClickEvent (item) {
      this.targetId = item.id
      this.enableItemUnitDialog = true
    },
    /**
     * 削除ボタン クリックイベント
     * @param item { Object }
     */
    deleteButtonClickEvent (item) {
      this.$refs.confirm.showDeleteConfirm().then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          this.deleteItemUnit({ id: item.id }).then(() =>{
            this.searchItemUnit()
          })
        }
      })
    },

    /**
     * モーダルを閉じる
     */
    closeItemUnitDialog () {
      this.enableItemUnitDialog = false;
    },
    /**
     * モーダルからのコールバック処理
     */
    itemUnitCallback (forms) {
      this.closeItemUnitDialog()
      this.searchItemUnit()
    },
    changePage(page) {
      this.page = page;
      this.searchItemUnit()
    },
    changePerPage (perPage) {
      this.perPage = perPage
      this.page = 1
      this.searchItemUnit()
    },
    /**
    * 売上品目単位 検索
    */
    searchItemUnit () {
      let params = this.buildParam('json')
      this.fetchSalesItemUnits(params).then((content) => {
        this.salesItemUnits = content.sales_item_units
      })
    },

    buildParam (format) {
      return {
        page: this.page,
        limit: this.perPage,
        format: format
      }
    }
  }
}
</script>

<style scoped lang="scss">
.panel-header-color {
  color: #0D74BA !important;
  & .v-expansion-panel-header__icon {
    & .v-icon {
      color: #0D74BA !important;
      &::before {
        color: #0D74BA !important;
      }
    }
  }
}
.panel-selectable {
  background-color: #DCE7EB;
}

</style>
